var React = require('react');

function MenuArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 13C1 13 7 8.68398 7 7C7 5.31602 1 1 1 1","stroke":"#E57B82","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

MenuArrow.defaultProps = {"width":"8","height":"14","viewBox":"0 0 8 14","fill":"none"};

module.exports = MenuArrow;

MenuArrow.default = MenuArrow;
